import BaseRichContentPage from './BaseRichContentPage';

new BaseRichContentPage();